export default __webpack_public_path__ + "static/media/angular.9eab41c6.PNG";